'use strict';

import ngResource from 'angular-resource';

function ActivePowerService($resource) {
  return $resource(
    '/api/active_power/:id',
    {id: '@id'},
    {
      show: {method: 'GET', isArray: false},
      upper_limit: {method: 'GET', isArray: false, url: '/api/active_power/:id/upper_limit'}
    }
  );
}

export default angular.module('leptonApp.ActivePowerService', ['ngResource'])
  .service('ActivePowerService', ['$resource', ActivePowerService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/active_power/active_power.service.js